export const enum EventPayloadType {
  RECORDING_LISTEN_EVENT = 'recordings::listen_event',
  RECORDING_PLAY_CLICKED = 'recordings::play_clicked'
}
interface EventPayload {
  type: EventPayloadType;
}

export interface RecordingListenEventPayload extends EventPayload {
  recording_id: string;
  owner_id: string;
  minute: number;
  recording_duration_minutes: number;
  recording_title: string;
}

export interface RecordingPlayClickedPayload extends EventPayload {
  recording_id: string;
  owner_id: string;
  recording_title: string;
}

export async function sendEvent(payload: EventPayload): Promise<boolean> {
  const result = await fetch(
    `${process.env.REACT_APP_API_GATEWAY_SEND_EVENT}`,
    {
      body: JSON.stringify(payload),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    }
  );

  if (result.ok) {
    return true;
  } else {
    return false;
  }
}
